export default __webpack_public_path__ + "static/media/wechat.e4ee5b4d.svg";